import React from 'react'
import styles from './internal.module.css'

const RestrictedPage = () => {
  return (
    <div className={styles.page}>
      <h1>Sorry!</h1>
      <p>You do not have access to this page.</p>
      <a className="dx-btn dx-btn-primary" href="/">
        Go to Homepage
      </a>
    </div>
  )
}

export default RestrictedPage
